import React, { useRef } from 'react';
import styled from 'styled-components';
import { CommonText, CommonTitle } from '@client/style/Text';
import HTML from '@client/core/utils/HTML';
import { Breakpoints, Colors } from '@client/style/Variables';
import Functions from '@client/style/Functions';
import WaveContainer from '../Dividers/WaveContainer';
import { SquareButton } from '../shared/SquareButton';
import { TextStyle } from '@client/style/TextStyles';
import { useSurroundingColors } from '../shared/UseSurroundingColors';
import Embed from '../Embed/Embed';

const Container = styled(WaveContainer)`
	width: 100vw;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.2);
	${Functions.breakpoint(Breakpoints.mobile)} {
		height: auto;
		aspect-ratio: 16/9;
	}
`;

const Content = styled.div`
	/* background-color: yellow; */
	pointer-events: none;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	z-index: 1;
	width: 100vw;
	height: 100vh;
	${Functions.breakpoint(Breakpoints.mobile)} {
		height: auto;
		aspect-ratio: 16/9;
		position: absolute;
	}
`;

const StyledCommonTitle = styled(CommonTitle)<{ $fg?: string }>`
	color: ${props => props.$fg || Colors.lightText};
	${TextStyle.size('h6')}
	max-width: 400px;
	position: relative;
	z-index: 1;
	pointer-events: auto;

	${Functions.breakpoint(Breakpoints.laptop)} {
		${TextStyle.size('h3')}
		max-width: 800px;
	}

	${Functions.breakpoint(Breakpoints.desktop)} {
		${TextStyle.size('h2')}
		max-width: 1000px;
	}
`;

const StyledVideo = styled(Embed)`
	position: absolute;
	aspect-ratio: 16/9;
	width: auto !important;
	height: 100vh !important;
	object-fit: cover;
	pointer-events: none;

	${Functions.breakpoint(Breakpoints.mobile)} {
		height: auto !important;
		width: 100vw !important;
	}
`;

const VideoContainer = styled.div`
	position: relative;
`;

const StyledCommonText = styled(CommonText)<{ $fg?: string }>`
	color: ${props => props.$fg || Colors.lightText};
	max-width: 400px;
	position: relative;
	z-index: 1;
	pointer-events: auto;

	${Functions.breakpoint(Breakpoints.laptop)} {
		max-width: 600px;
	}

	${Functions.breakpoint(Breakpoints.desktop)} {
		max-width: 1000px;
	}
	${Functions.breakpoint(Breakpoints.ultra)} {
		max-width: 1200px;
	}
`;

const StyledLinkButton = styled(SquareButton)`
	margin-top: 30px;
`;

const StyledBackground = styled.div<{ $bg?: string }>`
	position: absolute;
	left: 0;
	right: 0;
	height: 50%;
	background-color: ${props => props.$bg};
`;

export const VideoCTA = (props: any) => {
	const moduleRef = useRef<HTMLDivElement>(null);
	const backgroundColors = useSurroundingColors(moduleRef);

	return (
		<VideoContainer ref={moduleRef}>
			<StyledBackground $bg={backgroundColors[0]} style={{ top: 0 }} />
			<StyledBackground $bg={backgroundColors[1]} style={{ bottom: 0 }} />
			<Container side='both'>
				{/* <StyledVideo embedType='youtube' src={`https://youtu.be/${props.data.video.providerUid}`} inline={true} /> */}
				<StyledVideo embedType={props.data.video.provider} src={props.data.video.url} inline={true} />
				<Content>
					<StyledCommonTitle
						$fg={props.data.backgroundColorLink?.contrastColor}
						dangerouslySetInnerHTML={{ __html: HTML.clean(props.data.title) }}
					/>
					<StyledCommonText
						$fg={props.data.backgroundColorLink?.contrastColor}
						dangerouslySetInnerHTML={{ __html: HTML.clean(props.data.subtitle) }}
					/>

					{props.data.link.length > 0 && (
						<StyledLinkButton colors={props.data.link[0].buttonColorLink} link={props.data.link[0].link[0]}>
							{props.data.link[0].title ?? props.data.link[0].link[0]?.title}
						</StyledLinkButton>
					)}
				</Content>
			</Container>
		</VideoContainer>
	);
};
